import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../component/ui/button";
import { Input } from "../../component/ui/input";
import { Label } from "../../component/ui/label";
import {
  composeValidators,
  email,
  renderField,
  required,
  validatePassword,
} from "../../helpers/form-validations";
import { Field, Form } from "react-final-form";
import { EyeNoneIcon, EyeOpenIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import OTPComponent from "../../component/login/otpComponent";
import { login, sendResetPasswordLink } from "../../utils/util";
import { CircleArrowLeft } from "lucide-react";
import { useDispatch } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { alertDanger, alertSuccess } from "../../context/actions/toastAction";

// Fix for accessibility issues. Issue # VII26-106
export const description =
  "A login page with two columns. The first column has the login form with email and password. There's a Forgot your password link and a link to sign up if you do not have an account. The second column has a cover image.";

export function GetEmail({ onBack }) {
  const dispatch = useDispatch();
  const navigate=useNavigate()
  const [showPassword, setShowPassword] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  //   const onSubmit = (values) => {
  //     console.log(values); // Handle form submission here
  //   };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    // Save the isOTP state to localStorage whenever it changes

    localStorage.setItem("isOTPPage", isVerified);
  }, [isVerified]);

  const onSubmit = async (formData) => {
    dispatch(loaderSet(true));
    const Payload = {
      email: formData.email,
    };

    console.log("Email : ", Payload.email);

    try {
      const response = await sendResetPasswordLink(Payload);

      if (formData.email !== "") {
        localStorage.setItem("email", formData.email);
      }

      // Log the response to debug
      console.log("Login Response:", response);
      if (response) {
        if(response.code===200){
          onBack()
          dispatch(alertSuccess("Reset Link successfully sent to your email"))
          dispatch(loaderSet(false))

        }
        // if(response.code===404){
        //   // onBack()
        //   dispatch(alertDanger(response?.message))
        //   dispatch(loaderSet(false))

        // }
        else{
          dispatch(alertDanger(response?.message))
          dispatch(loaderSet(false))
        }
      }
      else{
        throw new Error("Internal Server Error")
      }
    } catch (error) {
      // Log error for debugging
      console.error("Error during send forgot password link:", error);
      dispatch(alertDanger(error.message))
      dispatch(loaderSet(false))
      //   setFormErrors({ general: 'An error occurred during login. Please try again.' });
    }
  };

  //   const backToLoginPageFromOTPPage=()=>{
  //     setIsVerified(false)
  //     localStorage.setItem("email",null)
  // }

  return (
    <>
      <div className="w-full  h-[100vh]  md:h-[100vh] lg:h-[100vh] xl:h-[100vh] 2xl:h-[100vh]">
        {/* Right side login */}
        <main className="flex  justify-center py-16 h-[100%] text-black " aria-labelledby="forgot-email-heading">
          <div className="mx-auto flex flex-col w-full gap-16">
            <div className=" flex justify-center items-center w-full">
              <Link to="/" aria-label="Vasuki India Home" className="rounded-md focus-visible:ring-2 focus-visible:ring-[#0D215C]">
                <img src="/vasuki-logo.svg" className="w-56" alt="Vasuki India logo" />
              </Link>
            </div>
            <Form
              onSubmit={onSubmit}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div className=" grid gap-2 pl-10 pr-10">
                    <div className="flex gap-4 pb-2 items-center text-[#0D215C] ">
                      <button
                        type="button"
                        onClick={onBack}
                        className="inline-flex items-center justify-center rounded-md focus-visible:ring-2 focus-visible:ring-[#0D215C]"
                        aria-label="Back to login"
                      >
                        <CircleArrowLeft className="size-6" aria-hidden="true" />
                      </button>
                      <div className="flex flex-col gap-0">
                        <h1 id="forgot-email-heading" className="text-lg font-semibold">
                          Forget Password
                        </h1>
                        <p className="text-sm">
                          Before resetting, think of all possible passwords
                        </p>
                      </div>
                    </div>
                    <div className="grid gap-2">
                      <Label
                        className="text-start text-[#0D215C] font-bold text-lg"
                        htmlFor="email"
                      >
                        Email
                      </Label>
                      <Field
                        id="email"
                        type="email"
                        name="email"
                        placeholder=" abc1234@gmail.com"
                        autoComplete="email"
                        validate={composeValidators(required, email)}
                        component={renderField} // Correct usage of renderField
                        className="bg-white h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                      />
                    </div>

                    <div className="flex justify-between py-2  w-full">
                      <Button type="submit" className="w-[40%] bg-[#0D215C]">
                        Send Resend Link
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            />
          </div>
        </main>
      </div>
    </>
  );
}

export default GetEmail;
